export const VALID_LOCATION_KEYS = ['id', 'airportCode', 'label', 'name', 'type', 'query', 'geoLocation', 'isDefault'];

export default VALID_LOCATION_KEYS;
